/**
 * The label on a Board Report "Priority Gaps" chip.
 *
 * PRISM's shared snapshot (the prism-data path the report reads) sends each gap as
 * { control, framework, severity, description } — the same shape Compass renders. The chip used to
 * read `gap.name`, which no producer ever sent, so every chip said "Unknown". A plain string is still
 * accepted. Nothing to show returns null and the caller leaves the chip out rather than inventing one.
 */
export type PrismGap =
  | string
  | { control?: string; framework?: string; severity?: string; description?: string };

export function boardReportGapLabel(gap: PrismGap | null | undefined): string | null {
  if (gap == null) return null;
  if (typeof gap === 'string') return gap.trim() || null;
  const control = (gap.control ?? '').trim();
  const description = (gap.description ?? '').trim();
  if (control && description) return `${control} — ${description}`;
  return control || description || null;
}
